function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Food = function Food(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M9.473 0a1 1 0 0 1 1 1v7.626A3.307 3.307 0 0 1 7.17 11.93h-.433v10.955a1 1 0 1 1-2 0V11.93h-.433A3.31 3.31 0 0 1 1 8.626V1a1 1 0 0 1 2 0v7.626c0 .719.585 1.304 1.304 1.304h.433V1a1 1 0 0 1 2 0v8.93h.433c.72 0 1.303-.585 1.303-1.304V1a1 1 0 0 1 1-1m11.242 2.076c.584.817 1.04 1.796 1.435 3.082.616 2.009.409 3.943-.569 5.304-.67.934-1.697 1.553-2.854 1.767v10.656a1 1 0 1 1-2 0l-.001-10.646a4.5 4.5 0 0 1-2.853-1.777c-.977-1.361-1.184-3.295-.568-5.304.393-1.286.85-2.265 1.434-3.082 1.8-2.514 4.177-2.514 5.976 0m-2.988.105c-.396 0-.866.366-1.363 1.059-.453.635-.819 1.43-1.147 2.504-.205.666-.585 2.345.28 3.552.476.662 1.31 1.045 2.2 1.016.976.046 1.785-.354 2.26-1.016.866-1.207.485-2.886.28-3.552-.328-1.074-.693-1.87-1.148-2.504-.345-.484-.862-1.06-1.362-1.06"
  }));
};
export default Food;